import * as T from 'io-ts';
import { DateTime } from 'luxon';
import { Timestamp } from 'firebase/firestore';
export const LuxonDateTimeT = new T.Type('LuxonDateTimeT', (u) => u instanceof DateTime, (u, c) => {
    if (!(u instanceof Timestamp)) {
        return T.failure(u, c);
    }
    return T.success(DateTime.fromJSDate(u.toDate()).setZone('Europe/London'));
}, (a) => Timestamp.fromDate(a.toJSDate()));
